// extracted by mini-css-extract-plugin
export default {"todos":"Todos_todos__VLoE8"};